import { Divider, Form, message } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react';

import { EPButton } from '@/components';
import { useStores } from '@/hooks/use-stores';

import { Entity } from '../../NodeWidget.types';
import { CompressorDetailsTabContainer } from './CompressorDetailsTab.styles';
import { getDeviceSuperType, deviceSuperTypeMapping } from '../EditAssetDrawer.utils';

const CompressorDetailsTab = observer(
  ({ entity, afterOpenChange }: { entity: Partial<Entity>; afterOpenChange: boolean }) => {
    const { pidEditStore } = useStores();
    const [form] = Form.useForm();
    const deviceSuperType = getDeviceSuperType(entity.deviceType);
    const FormComponent = deviceSuperTypeMapping[deviceSuperType]?.component;
    const [messageApi, contextHolder] = message.useMessage();

    return (
      <CompressorDetailsTabContainer>
        <div className="body">
          {FormComponent && (
            <FormComponent entity={entity} form={form} afterOpenChange={afterOpenChange} messageApi={messageApi} />
          )}
        </div>
        <Divider className="divider" />
        <div className="footer">
          {contextHolder}
          <EPButton type="primary" onClick={form.submit} loading={pidEditStore.isLoadingDraft}>
            {t(entity?.deviceId ? 'saveChanges' : 'addNew', { device: t(deviceSuperType) })}
          </EPButton>
        </div>
      </CompressorDetailsTabContainer>
    );
  },
);

export default CompressorDetailsTab;
